<template>
    <sa-page-layout :showModalLoading="showModalLoading" :btnRefreshVisible="true" :btnNewVisible="false" :pathResource="pathResource" @refresh="onRefresh" :linkedit="linkedit">
        <template slot="table-body">
            <team-system-integrator-list-component ref="cmpTeamSystemIntegratorList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
            <sa-modal-loading ref="mdlSaModalLoading"></sa-modal-loading>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import { SaModalLoading } from "../../utility";
import UtilityMixin from "../../utility/UtilityMixin";
import TeamSystemIntegratorListComponent from "../components/TeamsystemIntegratorListComponent.vue";
export default {
    components: { SaPageLayout, SaModalLoading, TeamSystemIntegratorListComponent },
    mixins: [UtilityMixin],
    computed: {
        rows() {
            return this.items.length;
        },
        externalPrenotazioniEnable: {
            get: function () {
                let me = this;
                return UtilityMixin.methods.verificaPermessi(me.utente, "externalprenotazioni", 1);
            },
        },
    },
    props: {
        utente: {
            required: true,
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            filter: null,
            id: "-1",
            pathResource: "/flussi",
            linkedit: "/struttura",
            filtro: {},
            filterOn: [],
            // externalPrenotazioniEnable: false,
            showModalLoading: false,
            fields: [
                {
                    label: "Tipo",
                    key: "tipo",
                    sortable: false,
                    // thStyle: "width: 0.25rem",
                },
                {
                    label: "Mese Riferimento",
                    key: "meseRiferimento",
                    sortable: false,
                    // thStyle: "width: 0.25rem",
                },
                {
                    label: "Anno Riferimento",
                    key: "annoRiferimento",
                    sortable: false,
                    // thStyle: "width: 0.25rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            items: [
                { tipo: "FILE H", meseRiferimento: "MARZO", annoRiferimento: "2025" },
                { tipo: "FILE H", meseRiferimento: "APRILE", annoRiferimento: "2025" },
            ],
        };
    },
    mounted: function () {
        let me = this;
        // me.externalPrenotazioniEnable = UtilityMixin.methods.verificaPermessi(me.utente, "pazienti", 4);
        me.loadData();
    },
    methods: {
        onBeforeLoadData() {
            let me = this;
            me.$refs.mdlSaModalLoading.show();
        },
        onAfterLoadData() {
            let me = this;
            me.$refs.mdlSaModalLoading.close();
        },
        loadData() {
            let me = this;
            me.$refs.cmpTeamSystemIntegratorList.init();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        // onClickNuovo() {
        //     let me = this;
        //     me.$refs.cmpFlussiModalEdit.show();
        // },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
